import { KIOSK_OPTIONS } from 'components/shared/Filters/lib/filterOptions';

export const DEFAULT_FILTERS = {
  last_active: {
    type: 'date-range',
    title: 'Date of service',
    icon: 'clock-mono'
  },
  id: KIOSK_OPTIONS,
  name: {
    title: 'Name',
    placeholder: 'Search name',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'first-line-mono'
  },
  color: {
    title: 'Color',
    placeholder: 'Search color',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'paint-bucket-mono'
  },
  state: {
    title: 'State',
    placeholder: 'Search state',
    allowed_operators: ['contains', 'does not contain'],
    icon: 'electronics-state-mono'
  },
  status: {
    title: 'Status',
    multiple: true,
    queryFn: (_, data) => {
      const searchTerm = data.filters.searchTerm || '';
      return {
        options: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' }
        ].filter((status) => status.label.toLowerCase().includes(searchTerm.toLowerCase()))
      };
    },
    queryKey: 'kiosk_status.options',
    icon: 'status-mono',
    allowed_operators: ['is any of', 'is not', 'is']
  }
};
